import { buildLastSolvedSelectedFinanceQuote, getAmountToFinance } from '../../utils/quoteUtils';
import copy from 'fast-copy';
import {
  ADD_APPLICATION_CHAT_SUCCESS,
  ADD_APPLICATION_NOTES_SUCCESS,
  ADD_CO_APPLICANT,
  ADD_NEW_APP_VEHICLE,
  ApplicationActionTypes,
  ApplicationState,
  CLEAR_APPLICATION_CHATS,
  CREATE_APPLICATION_DOWN_PAYMENT_REQUEST,
  CREATE_APPLICATION_DOWN_PAYMENT_REQUEST_SUCCESS,
  CREATE_APPLICATION_DOWN_PAYMENT_REQUEST_FAILURE,
  CLEAR_NEWLY_CREATED_DOWN_PAYMENT_REQUEST,
  CREATE_APPLICATION_FROM_DEALER_FORM_SUCCESS,
  CREATE_APPLICATION_SUCCESS,
  CREATE_CASH_DEAL_APPLICATION_SUCCESS,
  CREATE_CUSTOMER_REFERENCE_SUCCESS,
  CREATE_EMPLOYEE_APPLICATION_HISTORY_SUCCESS,
  CREATE_INCOME_SUCCESS,
  CREATE_ORGANIZATION_SUCCESS,
  DELETE_CUSTOMER_REFERENCE_SUCCESS,
  DELETE_INCOME_SUCCESS,
  GET_700_CREDIT_TRANSACTION_ID,
  GET_APPLICATION_CHAT_SUCCESS,
  GET_APPLICATION_REHASH_SUCCESS,
  GET_APPLICATION_SCORE,
  GET_DEALERTRACK_APPLICATION_HISTORY_SUCCESS,
  GET_PREVIOUS_AMS_LOANS_SUCCESS,
  LOAD_APPLICATION_QUEUE_COUNTS_SUCCESS,
  LOAD_APPLICATION_QUEUE_DATA,
  LOAD_CURRENT_RELEASE_NOTES_SUCCESS,
  LOAD_EMAIL_NOTIFICATIONS_SUCCESS,
  LOAD_EMPLOYEE_APPLICATION_HISTORIES_SUCCESS,
  LOAD_JDPOWERSPORT_HISTORY_SUCCESS,
  LOAD_LIBRARY_SUCCESS,
  LOAD_MANAGEMENT_ORGANIZATIONS_SUCCESS,
  LOAD_RELEASE_NOTES_SUCCESS,
  SEND_CUSTOMER_REFERENCES_TO_AMS_SUCCESS,
  SET_APP_DIRTY,
  SET_APP_STATUS_WORLFLOWS,
  SET_APP_STATUSES,
  SET_AUTHENTICATION_TIMED_OUT,
  SET_IP_BLOCKED,
  SET_CLEAR_SERVER_MESSAGE,
  SET_CUSTOM_FIELDS,
  SET_CUSTOMER_ROLES,
  SET_DEAL_STATS,
  SET_DISABLED_APP_STATUSES,
  SET_EDITING_APP,
  SET_EMPLOYEE_ROLES,
  SET_EMPLOYEES,
  SET_HOUSING_STATUSES,
  SET_INCOME_PERIODS,
  SET_INCOME_TYPES,
  SET_INCOMPLETE_APPCUSTOMERS_STIPULATION_CATEGORIES,
  SET_INITIAL_LOAD_COMPLETE,
  SET_JOB_CODES,
  SET_JOB_TYPES,
  SET_LOADING,
  SET_AMS_ACV_PERMISSIONS,
  SET_LOGGED_IN_USER,
  SET_MARITAL_STATUSES,
  SET_QUOTE_PAY_TYPES,
  SET_QUOTE_PAYMENT_INFO,
  SET_SERVER_MESSAGE,
  SET_SHOULD_OPEN_GENERATE_PORTAL_LINK_DIALOG,
  SET_STATES,
  SET_VEHICLE_INFO,
  SET_VEHICLE_JDPOWER,
  SET_VEHICLES,
  SET_WORK_SHIFTS,
  UPDATE_APP_LOCK,
  UPDATE_APP_VEHICLE_PRICE,
  UPDATE_APPLICATION_CHECKLIST_SUCCESS,
  UPDATE_APPLICATION_EXCEPTIONS_SUCCESS,
  UPDATE_APPLICATION_FINANCE_QUOTES,
  UPDATE_APPLICATION_FINANCE_QUOTES_SUCCESS,
  SOLVE_LEASE_QUOTE_SUCCESS,
  SET_LEASE_QUOTE_NEEDS_SOLVE,
  UPDATE_APPLICATION_QUEUE_FILTERS_SUCCESS,
  UPDATE_APPLICATION_QUOTE_USE_VEHICLE,
  UPDATE_BUDGET,
  UPDATE_CREDIT_APP_FORM_CONFIGURATIONS_SUCCESS,
  UPDATE_CUSTOMER_CREDIT,
  UPDATE_CUSTOMER_REFERENCE_SUCCESS,
  UPDATE_CUSTOMER_REFERENCE_VERIFICATION_SUCCESS,
  UPDATE_EDITING_APP,
  UPDATE_EMPLOYEE_AVAILABILITY_STATUS_SUCCESS_ACTION,
  UPDATE_INCOME_SUCCESS,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_KEY_FACTOR_VALIDATION_RESULTS,
  UPDATE_UNDO_APPLICATION_EXCEPTIONS_SUCCESS,
  SET_APPLICANT_CREDIT_APP_FORM_CONFIG,
  SET_CO_APPLICANT_CREDIT_APP_FORM_CONFIG,
  CLEAR_APPLICATION_SCORE,
  CLEAR_PREVIOUS_AMS_LOANS,
  CLEAR_APPLICATION_REHASHES,
  UPDATE_VEHICLE_SUCCESS,
  SET_APP_LOADED_BUSINESS_RULES_HAVE_RUN,
  GET_CARLETON_APR_FOR_APPLICATION_FUNDING_SUCCESS,
  SET_GLOBAL_SEARCH_TEXT,
  SET_IS_GLOBALLY_SEARCHING,
  CANCEL_GLOBAL_SEARCH,
  LOAD_GLOBAL_SEARCH_ITEMS_SUCCESS,
  LOAD_GLOBAL_SEARCH_ITEMS,
  SET_IS_LOADING_GLOBAL_SEARCH_PAGE,
  GET_DOWN_PAYMENT_HISTORIES_SUCCESS,
  UPDATE_AMS_CUSTOMER_NUMBER_SUCCESS,
  GET_NEW_SIGNED_URL_SUCCESS,
  GET_SIGNED_URLS_SUCCESS,
  CLEAR_ALL_APPLICATION_QUEUES_FILTERS_SUCCESS, 
  VOID_DOWN_PAYMENT_SUCCESS,
} from './types';
import { getLatestException } from '../../utils/appUtils';
import { isNil } from 'lodash';
import {
  Constants,
  defaultDisclosure,
  defaultHelpDeskUrl,
  numberOfEmployeeApplicationHistoriesToTrack,
  OrganizationIds,
} from '../../utils/constants';
import { ICustomField } from '../../Interfaces/Common/ICustomField';
import deepEqual from 'deep-equal';
import { getLeaseVehicleEditEffect } from '../../utils/leaseQuoteSolveUtils';
import { ApplicationQuoteType, hasValue, Organization } from '@amsanalytics/react-shared-library';
import {
  ApplicationActions,
  GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS,
  GET_PERFORMANCE_EVALUATION_SUCCESS,
  SET_STIPULATION_CATEGORIES,
} from './actions';
import { defaultBureauFavorites } from '../../Data/BureauFavorites';
import { getDefaultApplicationQueueSort } from '../../utils/utils';
import { IndirectQuoteType } from '../../Data/IndirectQuoteType';
import { AppStatusesToRequireAdverseActionReasons } from '../../Interfaces/Enums/AppStatusesToRequireAdverseActionReasons';

const initialState: ApplicationState = {
  loadingInitialData: true,
  dealStats: { OpenDeals: 0, OpenDealsMTD: 0, ClosedMTD: 0, ClosedToday: 0 },
  appStatuses: [],
  disabledAppStatuses: [],
  states: [],
  employees: [],
  vehicles: [],
  housingStatuses: [],
  maritalStatuses: [],
  quotePayTypes: [],
  customFields: [],
  customerRoles: [],
  employeeRoles: [],
  incomePeriods: [],
  incomeTypes: [],
  jobCodes: [],
  jobTypes: [],
  workShifts: [],
  loading: false,
  editingApp: undefined,
  signedUrls: {},
  applicationChats: [],
  // dealertrackDealerDecisionData: undefined,
  appDirty: false,
  financeQuoteIsDirty: false,
  applicationLeaseQuoteIsDirty: false,
  applicationLeaseQuoteNeedsSolve: false,
  leaseQuoteSolvedRollback: null,
  loggedInUser: undefined,
  amsAcvPermissions: undefined,
  quotePaymentInfo: undefined,
  serverMessage: { message: '', isError: false },
  newApplicationId: undefined,
  shouldOpenGeneratePortalLinkDialog: false,
  applicationStatusWorkflows: [],
  dealerServiceAppHistoryItems: {
    currentDecisionId: null,
    applicationsReceived: [],
    acknowledgementsReceived: [],
    commentsReceived: [],
    decisionsSent: [],
    commentsSent: [],
    documentsReceivedAcknowledgementSent: [],
  },
  lookupsLoaded: false,
  managementOrganizations: [],
  lookups: {
    dealerServiceDecisionCodes: [],
    dealerServiceDecisionReasonCodes: [],
    dealerServiceDecisionCodeWorkflowItems: [],
    applicationAssignableRoles: [],
    applicationExceptionStatuses: [],
    identificationTypes: [],
    checklists: [],
    checklistItems: [],
    checklistItemStatuses: [],
    employeeRoleChecklists: [],
    customerReferenceRelationships: [],
    customerEmploymentStatuses: [],
    customerEmploymentVerificationOptions: [],
    leaseLoanClasses: [],
    leaseFees: [],
    financeLoanClasses: [],
    scoreTypes: [],
    applicationQueues: [],
    externalApplicationStatuses: [],
    rehashTypes: [],
    jdPowerRegions: [],
    availabilityStatuses: [],
    stipulationCategoryStatuses: [],
    carletonItems: [],
    carletonInsuranceCoverageTypes: [],
    disclosure: defaultDisclosure,
    spanishDisclosure: null,
    helpDeskUrl: defaultHelpDeskUrl,
    acceptedStipulationDocumentStatuses: [],
    minimumMonthsOfAddressInformation: 0,
    minimumMonthsOfEmploymentInformation: 0,
    usePaymentCallTransactionType: false,
    applicantAddressStateIdsToFilterBy: [], // list of state ids by which we should filter the list of states for the address state dropdown. If empty, all states will be shown.
    employerAddressStateIdsToFilterBy: [], // list of state ids by which we should filter the list of states for the employer state dropdown. If empty, all states will be shown.
    driverLicenseStateIdsToFilterBy: [], // list of state ids by which we should filter the list of states for the driver license state dropdown. If empty, all states will be shown.
    relationshipToApplicants: [],
    privacyPolicyUrl: '', // url to the privacy policy
    termsAndConditionsUrl: '', // url to the terms and conditions
    organizations: [], // list of organizations
    clients: [], // list of clients
    adUserIdDomains: [], // list of email domains that can be used when creating users
    bookoutSources: [],
    vehicleDepreciationRate: null,
    languageTranslations: [],
    bureauFavorites: defaultBureauFavorites,
    allowSpanishTranslation: true,
    embedCreditApplicationVersion: 1,
    crmLosCreditApplicationVersion: 1,
    businessRuleOverrideStatuses: [],
    accountOwners: [],
    advertisings: [],
    dealerNumbers: [],
    amsLateFees: [],
    loanCodes: [],
    loanTypes: [],
    locationOfPayments: [],
    vehicleLocationsOfPurchase: [],
    portfolios: [],
    receiptMessages: [],
    amsUsers: [],
    tagLabels: [],
    passTimeUnitTypes: [],
    passTimeConfigs: [],
    paymentSources: [],
    paymentProcessors: [],
    paymentDeliveryMethods: [],
    cashDrawers: [],
    cashDrawerAssignments: [],
    cpiConfigs: [],
    financeCompanies: [],
    canCreateFinanceApplication: false,
    canCreateLeaseApplication: false,
    canCreateIndirectApplication: false,
    applicationStipulationStatuses: [],
    validationRuleStatusOverrides: [],
    appStatusesToRequireAdverseActionReasons: AppStatusesToRequireAdverseActionReasons.None, // Not a list of app statuses — single enum: None = 0, Denied = 1, ConditionallyApproved = 2, Both = 3
    interestTypes: [],
    financeWarranties: [],
  },
  applicationChecklists: [],
  applicationQueueDetails: [],
  creditPullPrimaryTransactionId: undefined,
  applicationScore: undefined,
  previousAmsLoans: undefined,
  applicationRehashes: [],
  incompleteAppCustomerStipulationCategories: [],
  jdPowersportHistories: [],
  emailNotificationItems: [],
  appLoadedBusinessRulesHaveRun: false,
  releaseNotes: [],
  applicationPerformanceIndicatorEvaluations: [],
  scoreEditorPerformanceIndicatorEvaluations: [],
  employeeApplicationHistories: [],
  keyFactorValidationResults: [],
  stipulationCategories: null,
  newlyCreatedDownPaymentRequest: null,
  downPaymentRequestError: null,
  globalSearchText: '',
  isGloballySearchingApps: false,
  loadingGlobalSearchPage: false,
  globalSearchPage: { count: 0, applications: [] },
  lastSolvedSelectedFinanceQuote: undefined,
};

export const applicationReducer = (
  state = initialState,
  action: ApplicationActionTypes | ApplicationActions
): ApplicationState => {
  switch (action.type) {
    case SET_AUTHENTICATION_TIMED_OUT:
      return {
        ...state,
        authenticationTimedOut: action.payload,
      };

    case SET_IP_BLOCKED:
      return {
        ...state,
        ipBlocked: action.payload.blocked,
        ipBlockedMessage: action.payload.message,
      };

    case SET_DEAL_STATS:
      return {
        ...state,
        dealStats: action.payload,
      };

    case SET_APP_STATUSES:
      return {
        ...state,
        appStatuses: action.payload,
      };
    case SET_DISABLED_APP_STATUSES:
      return {
        ...state,
        disabledAppStatuses: action.payload,
      };
    case SET_INCOMPLETE_APPCUSTOMERS_STIPULATION_CATEGORIES:
      return {
        ...state,
        incompleteAppCustomerStipulationCategories: action.payload,
      };
    case SET_APP_STATUS_WORLFLOWS:
      return {
        ...state,
        applicationStatusWorkflows: action.payload,
      };
    case SET_HOUSING_STATUSES:
      return {
        ...state,
        housingStatuses: action.payload,
      };

    case SET_STATES:
      return {
        ...state,
        states: action.payload,
      };

    case UPDATE_EDITING_APP:
      const updatedApp = copy(action.payload);
      const leaseQuoteEdited = !deepEqual(updatedApp.applicationLeaseQuote, state.editingApp?.applicationLeaseQuote);
      // A vehicle attached without a Solve (same price, so the quote itself did not change).
      const leaseVehicleChanged = updatedApp.quoteType === ApplicationQuoteType.Lease && !!updatedApp.applicationLeaseQuote
        && updatedApp.vehicleId !== state.editingApp?.vehicleId;
      return {
        ...state,
        editingApp: updatedApp,
        // Only actually set this to dirty if the objects are different
        appDirty: !deepEqual(updatedApp, state.editingApp),
        // Only sets it to dirty === true and also only does the deepEqual comparison when it is false
        financeQuoteIsDirty:
          !state.financeQuoteIsDirty &&
          !deepEqual(updatedApp.financeQuotes, state.editingApp?.financeQuotes)
            ? true
            : state.financeQuoteIsDirty,
        applicationLeaseQuoteIsDirty: state.applicationLeaseQuoteIsDirty || leaseQuoteEdited,
        applicationLeaseQuoteNeedsSolve: state.applicationLeaseQuoteNeedsSolve || leaseQuoteEdited || leaseVehicleChanged,
      };
    case UPDATE_APP_LOCK:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              unlockedBySuperUser: action.payload,
            }
          : undefined,
        appDirty: true,
      };
    case 'UNLOCK_APPLICATION_SECTIONS_SUCCESS':
      return {
        ...state,
        editingApp: state.editingApp
          ? { ...state.editingApp, activeUnlock: action.payload }
          : undefined,
      };
    case 'FETCH_ACTIVE_UNLOCK_SUCCESS':
      return {
        ...state,
        editingApp: state.editingApp
          ? { ...state.editingApp, activeUnlock: action.payload }
          : undefined,
      };
    case 'RELOCK_APPLICATION_SUCCESS':
    case 'CLEAR_ACTIVE_UNLOCK':
      return {
        ...state,
        editingApp: state.editingApp
          ? { ...state.editingApp, activeUnlock: null }
          : undefined,
      };
    case UPDATE_BUDGET:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationBudget: action.payload,
            }
          : undefined,
        appDirty: true,
      };
    case UPDATE_EMPLOYEE_AVAILABILITY_STATUS_SUCCESS_ACTION:
      return {
        ...state,
        loggedInUser: state.loggedInUser
          ? {
              ...state.loggedInUser,
              employee: {
                ...state.loggedInUser.employee,
                availabilityStatusId: action.payload.statusId,
              },
            }
          : state.loggedInUser,
      };
    case UPDATE_APPLICATION_QUOTE_USE_VEHICLE:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationQuotes: state.editingApp.applicationQuotes.map((aq) => {
                if (aq.id === action.payload.applicationQuoteId) {
                  const carPrice =
                    action.payload.useVehiclePrice === true && state.editingApp?.vehicle
                      ? state.editingApp.vehicle.carPrice
                      : aq.quote.carSalePrice;
                  return {
                    ...aq,
                    useVehiclePrice: action.payload.useVehiclePrice,
                    quote: {
                      ...aq.quote,
                      carSalePrice: carPrice,
                      amountToFinance: action.payload.useVehiclePrice
                        ? getAmountToFinance(aq.quote, carPrice ?? 0)
                        : aq.quote.amountToFinance,
                    },
                  };
                }
                return aq;
              }),
            }
          : undefined,
        appDirty: true,
      };
    case UPDATE_APP_VEHICLE_PRICE:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              vehicle:
                state.editingApp.vehicle !== undefined &&
                state.editingApp.vehicle != null &&
                state.editingApp.vehicle.id === action.payload.vehicleUpdateInfo.vehicleId
                  ? {
                      ...state.editingApp.vehicle,
                      carPrice: action.payload.vehicleUpdateInfo.vehiclePrice,
                    }
                  : state.editingApp.vehicle,
              applicationQuotes: state.editingApp.applicationQuotes.map((aq) => {
                if (aq.quote.quoteType === IndirectQuoteType.Recommended) {
                  return {
                    ...aq,
                    quote: {
                      ...aq.quote,
                      carSalePrice: action.payload.vehicleUpdateInfo.vehiclePrice,
                    },
                  };
                } else {
                  return aq;
                }
              }),
            }
          : state.editingApp,
      };
    case SET_EDITING_APP:
      const payloadApplicationIsNotUndefined = !!action.payload;
      const applicationIdsAreTheSame = payloadApplicationIsNotUndefined && action.payload!.id === state.editingApp?.id;
      return {
        ...state,
        keyFactorValidationResults: [],
        editingApp: action.payload,
        signedUrls: applicationIdsAreTheSame ? state.signedUrls : {},
        appDirty: false,
        financeQuoteIsDirty: false,
        applicationLeaseQuoteIsDirty: false,
        applicationLeaseQuoteNeedsSolve: action.payload?.leaseQuoteNeedsSolve === true,
        // A quote solved for its saved inputs holds the target of that Solve.
        leaseQuoteSolvedRollback: action.payload?.leaseQuoteNeedsSolve === false
          ? action.payload.applicationLeaseQuote?.totalDownRollback ?? 0
          : null,
        incompleteAppCustomerStipulationCategories: action.payload ? state.incompleteAppCustomerStipulationCategories : [], // If the editing app is null or undefined, then clear the incompleteAppCustomerStipulationCategories
        appLoadedBusinessRulesHaveRun:
          payloadApplicationIsNotUndefined && applicationIdsAreTheSame ? state.appLoadedBusinessRulesHaveRun : false,
        stipulationCategories: action.payload ? state.stipulationCategories : null, // If the editing app is null or undefined, then clear the stipulationCategories
        lastSolvedSelectedFinanceQuote: buildLastSolvedSelectedFinanceQuote(action.payload?.financeQuotes),
      };
    case CLEAR_APPLICATION_CHATS:
      return {
        ...state,
        applicationChats: [],
      };

    case SET_INCOME_PERIODS:
      return {
        ...state,
        incomePeriods: action.payload,
      };

    case SET_INCOME_TYPES:
      return {
        ...state,
        incomeTypes: action.payload,
      };
    case SET_JOB_CODES:
      return {
        ...state,
        jobCodes: action.payload,
      };
    case SET_JOB_TYPES:
      return {
        ...state,
        jobTypes: action.payload,
      };
    case SET_WORK_SHIFTS:
      return {
        ...state,
        workShifts: action.payload,
      };

    case SET_MARITAL_STATUSES:
      return {
        ...state,
        maritalStatuses: action.payload,
      };

    case SET_QUOTE_PAY_TYPES:
      return {
        ...state,
        quotePayTypes: action.payload,
      };
    case SET_STIPULATION_CATEGORIES:
      return {
        ...state,
        stipulationCategories: action.payload.stipulationCategories,
      };
    case SET_APP_DIRTY:
      return {
        ...state,
        appDirty: action.payload,
      };

    case SET_LOGGED_IN_USER:
      return {
        ...state,
        loggedInUser: action.payload,
      };
    case SET_AMS_ACV_PERMISSIONS:
      return {
        ...state,
        amsAcvPermissions: action.payload,
      };
    case SET_QUOTE_PAYMENT_INFO:
      return {
        ...state,
        quotePaymentInfo: action.payload,
      };

    case SET_EMPLOYEES:
      return {
        ...state,
        employees: action.payload,
      };

    case SET_VEHICLES:
      return {
        ...state,
        vehicles: action.payload,
      };
    case SET_CUSTOM_FIELDS:
      return {
        ...state,
        customFields: action.payload,
      };

    case SET_CUSTOMER_ROLES:
      return {
        ...state,
        customerRoles: action.payload,
      };

    case SET_EMPLOYEE_ROLES:
      return {
        ...state,
        employeeRoles: action.payload,
      };

    case SET_INITIAL_LOAD_COMPLETE:
      return {
        ...state,
        loadingInitialData: false, // done loading the initial state from server
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_CLEAR_SERVER_MESSAGE:
      return {
        ...state,
        serverMessage: { isError: false, message: '' },
      };

    case SET_SERVER_MESSAGE:
      return {
        ...state,
        serverMessage: { isError: action.payload.isError, message: action.payload.message },
      };
    case CREATE_APPLICATION_SUCCESS:
      return {
        ...state,
        newApplicationId: action.payload.applicationId,
      };
    case CREATE_APPLICATION_FROM_DEALER_FORM_SUCCESS:
      return {
        ...state,
        newApplicationId: action.payload.applicationId,
      };
    case CREATE_CASH_DEAL_APPLICATION_SUCCESS:
      return {
        ...state,
        newApplicationId: action.payload.applicationId,
      };
    case SET_SHOULD_OPEN_GENERATE_PORTAL_LINK_DIALOG:
      return {
        ...state,
        shouldOpenGeneratePortalLinkDialog: action.payload,
      };
    case UPDATE_CUSTOMER_CREDIT:
      // First need to find out if the customer credit is being updated or is entirely new.
      const isUpdate =
        state.editingApp?.appCustomers
          .find((ac) => ac.customerId === action.payload.customerCredit?.customerId)
          ?.customer?.customerCredit.find((cc) => cc.id === action.payload.customerCredit?.id) !== undefined;

      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: state.editingApp.appCustomers.map((ac) => {
                if (ac.customerId === action.payload.customerCredit?.customerId) {
                  return {
                    ...ac,
                    customer: {
                      ...ac.customer,
                      customerCredit: isUpdate
                        ? ac.customer.customerCredit.map((cc) => {
                            if (cc.id === action.payload.customerCredit?.id) {
                              return action.payload.customerCredit;
                            }
                            return cc;
                          })
                        : [...ac.customer.customerCredit, action.payload.customerCredit],
                    },
                  };
                } else {
                  return ac;
                }
              }),
            }
          : state.editingApp,
      };
    case ADD_CO_APPLICANT:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: [...state.editingApp.appCustomers, action.payload],
            }
          : state.editingApp,
      };
    case ADD_APPLICATION_NOTES_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationNotes: [...state.editingApp.applicationNotes, ...action.payload.notes],
            }
          : state.editingApp,
      };
    case ADD_APPLICATION_CHAT_SUCCESS:
      return {
        ...state,
        applicationChats: [...state.applicationChats, action.payload.applicationChat],
      };
    case UPDATE_APPLICATION_EXCEPTIONS_SUCCESS:
      // Filters out which exceptions are the new ones, if any
      const newApplicationExceptions = action.payload.applicationExceptionsCustomField.applicationExceptions.filter(
        (uae) => !state.editingApp?.applicationExceptions.map((ae) => ae.id).includes(uae.id)
      );
      const latestException = getLatestException(action.payload.applicationExceptionsCustomField.applicationExceptions);

      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationExceptions: [
                ...state.editingApp.applicationExceptions.map((ae) => {
                  const matchedApplicationException = action.payload.applicationExceptionsCustomField.applicationExceptions.find(
                    (uae) => uae.id === ae.id
                  );
                  if (matchedApplicationException) {
                    return {
                      ...ae,
                      applicationExceptionStatusId: matchedApplicationException.applicationExceptionStatusId,
                      decisionReasonMessage: matchedApplicationException.decisionReasonMessage,
                      exceptionMessage: matchedApplicationException.exceptionMessage,
                      requestedValue: matchedApplicationException.requestedValue,
                      originalValue: matchedApplicationException.originalValue,
                      modifiedDate: matchedApplicationException.modifiedDate,
                      modifiedBy: matchedApplicationException.modifiedBy,
                    };
                  } else {
                    return ae;
                  }
                }),
                ...newApplicationExceptions,
              ],
              applicationCustomFields: state.editingApp.applicationCustomFields.map((acf) => {
                if (
                  acf.customField?.name ===
                  action.payload.applicationExceptionsCustomField.applicationCustomField.customField?.name
                ) {
                  return {
                    ...acf,
                    // Assigning the ID so that it doesn't try to save an additional custom field for the same name
                    id: action.payload.applicationExceptionsCustomField.applicationCustomField.id,
                    value:
                      latestException?.applicationExceptionStatusId === Constants.applicationExceptionStatuses.grantedId
                        ? action.payload.applicationExceptionsCustomField.applicationCustomField.value
                        : // Grabs the current value in the UI rather than using the value from the DB just in case it has changed
                          (state.editingApp!.applicationCustomFields.find(
                            (ac) => ac.customField.name === latestException?.sourceCustomFieldName
                          )?.value ?? ''),
                  };
                } else {
                  return acf;
                }
              }),
            }
          : state.editingApp,
      };
    case UPDATE_UNDO_APPLICATION_EXCEPTIONS_SUCCESS:
      // Filters out which exceptions are the new ones, if any
      const newApplicationExceptionsAfterUndo = action.payload.applicationExceptions.filter(
        (uae) => !state.editingApp?.applicationExceptions.map((ae) => ae.id).includes(uae.id)
      );

      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationExceptions: [
                ...state.editingApp.applicationExceptions.map((ae) => {
                  const matchedApplicationException = action.payload.applicationExceptions.find((uae) => uae.id === ae.id);
                  if (matchedApplicationException) {
                    return {
                      ...ae,
                      applicationExceptionStatusId: matchedApplicationException.applicationExceptionStatusId,
                      decisionReasonMessage: matchedApplicationException.decisionReasonMessage,
                      exceptionMessage: matchedApplicationException.exceptionMessage,
                      requestedValue: matchedApplicationException.requestedValue,
                      originalValue: matchedApplicationException.originalValue,
                      modifiedDate: matchedApplicationException.modifiedDate,
                      modifiedBy: matchedApplicationException.modifiedBy,
                    };
                  } else {
                    return ae;
                  }
                }),
                ...newApplicationExceptionsAfterUndo,
              ],
            }
          : state.editingApp,
      };
    case UPDATE_APPLICATION_CHECKLIST_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              applicationChecklists: state.editingApp.applicationChecklists.map((ac) => {
                if (ac.id === action.payload.checklist.id) {
                  return action.payload.checklist;
                }
                return ac;
              }),
            }
          : state.editingApp,
      };
    // case GET_DEALERTRACK_APPLICATION_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     dealertrackDealerDecisionData: action.payload.dealertrackDealerDecisionData
    //   };
    // case SET_DEALER_REQUEST_TRANSACTIONTYPE:
    //   if (state?.dealertrackDealerDecisionData) {
    //     return {
    //       ...state,
    //       dealertrackDealerDecisionData: {
    //         ...state.dealertrackDealerDecisionData,
    //         transactionType: action.payload.transactionType
    //       }
    //     }
    //   }
    //   return state;
    case GET_DEALERTRACK_APPLICATION_HISTORY_SUCCESS:
      return {
        ...state,
        dealerServiceAppHistoryItems: action.payload.dealerServiceAppHistoryItems,
      };
    case GET_APPLICATION_CHAT_SUCCESS:
      return {
        ...state,
        applicationChats: [...action.payload.applicationChats],
      };
    case LOAD_JDPOWERSPORT_HISTORY_SUCCESS:
      return {
        ...state,
        jdPowersportHistories: action.payload.histories,
      };
    case LOAD_EMAIL_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        emailNotificationItems: action.payload.emailNotificationItems,
      };

    case LOAD_LIBRARY_SUCCESS:
      return {
        ...state,
        lookupsLoaded: true,
        lookups: {
          ...action.payload,
          disclosure: hasValue(action.payload.disclosure) ? action.payload.disclosure : defaultDisclosure,
          organizations: action.payload.organizations.map((org: Organization) => {
            return {
              ...org,
              businessHours: org.businessHours.map((bh) => {
                return {
                  ...bh,
                  startTime: bh.startTime ? new Date(bh.startTime) : new Date(),
                  endTime: bh.endTime ? new Date(bh.endTime) : new Date(),
                };
              }),
            };
          }),
        },
        applicationQueueDetails: action.payload.applicationQueues.map((aq) => {
          return {
            id: aq.id,
            count: 0,
            loading: false,
            filters: getDefaultApplicationQueueSort(aq),
          };
        }),
      };
    case LOAD_MANAGEMENT_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        // Includes StorageLot orgs. Mirror the LOAD_LIBRARY_SUCCESS businessHours -> Date conversion so the editor gets Dates.
        managementOrganizations: action.payload.map((org: Organization) => {
          return {
            ...org,
            businessHours: (org.businessHours || []).map((bh) => {
              return {
                ...bh,
                startTime: bh.startTime ? new Date(bh.startTime) : new Date(),
                endTime: bh.endTime ? new Date(bh.endTime) : new Date(),
              };
            }),
          };
        }),
      };
    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        lookups: {
          ...state.lookups,
          // Keep StorageLot orgs out of the shared list (they live only on the org-management page, which
          // reads managementOrganizations and reloads itself after this action).
          organizations: action.payload.typeId?.toLowerCase() === OrganizationIds.storageLot
            ? state.lookups.organizations
            : [...state.lookups.organizations, action.payload],
        },
      };
    case UPDATE_ORGANIZATION_SUCCESS: {
      // Transition-aware so StorageLot can't leak via stale state: if the org is now a StorageLot, drop it
      // from the shared list (handles Store -> StorageLot); otherwise upsert in place (handles StorageLot ->
      // Store reappearing, plus normal edits).
      const isMatch = (org: Organization) => org.id?.toUpperCase() === action.payload.id.toUpperCase();
      const becameStorageLot = action.payload.typeId?.toLowerCase() === OrganizationIds.storageLot;
      const organizations = becameStorageLot
        ? state.lookups.organizations.filter((org) => !isMatch(org))
        : state.lookups.organizations.some(isMatch)
          ? state.lookups.organizations.map((org) => (isMatch(org) ? action.payload : org))
          : [...state.lookups.organizations, action.payload];
      return { ...state, lookups: { ...state.lookups, organizations } };
    }
    case SET_APPLICANT_CREDIT_APP_FORM_CONFIG:
      return {
        ...state,
        applicantCreditAppFormConfiguration: hasValue(action.payload.applicantCreditAppFormConfig)
          ? JSON.parse(action.payload.applicantCreditAppFormConfig!)
          : null,
      };
    case SET_CO_APPLICANT_CREDIT_APP_FORM_CONFIG:
      return {
        ...state,
        coApplicantCreditAppFormConfiguration: hasValue(action.payload.coApplicantCreditAppFormConfig)
          ? JSON.parse(action.payload.coApplicantCreditAppFormConfig!)
          : null,
      };
    case UPDATE_CREDIT_APP_FORM_CONFIGURATIONS_SUCCESS:
      return {
        ...state,
        applicantCreditAppFormConfiguration: action.payload.creditAppFormConfigurationDetails.applicantCreditAppFormConfiguration,
        coApplicantCreditAppFormConfiguration:
          action.payload.creditAppFormConfigurationDetails.coApplicantCreditAppFormConfiguration,
        customFields: state.customFields.map((cf: ICustomField) => {
          const updatedCustomField = action.payload.creditAppFormConfigurationDetails.customFields.find(
            (custField) => custField.id === cf.id
          );
          if (isNil(updatedCustomField)) {
            return cf;
          } else {
            return {
              ...cf,
              displayOnCreditApplicationForm: updatedCustomField.displayOnCreditApplicationForm,
            };
          }
        }),
      };
    case LOAD_APPLICATION_QUEUE_DATA:
      return {
        ...state,
        applicationQueueDetails: state.applicationQueueDetails.map((aqd) => {
          if (aqd.id === action.payload.applicationQueueId) {
            return {
              ...aqd,
              count: action.payload.count,
              loading: false,
            };
          } else {
            return aqd;
          }
        }),
        // dealertrackDealerDecisionData: undefined,
        dealerServiceAppHistoryItems: initialState.dealerServiceAppHistoryItems,
      };
    case LOAD_APPLICATION_QUEUE_COUNTS_SUCCESS:
      return {
        ...state,
        applicationQueueDetails: state.applicationQueueDetails.map((aqd) => {
          const matchedQueueDetail = action.payload.find((aqcr) => aqcr.queueId === aqd.id);
          if (matchedQueueDetail) {
            return {
              ...aqd,
              count: matchedQueueDetail.count,
            };
          } else {
            return aqd;
          }
        }),
      };
    case CLEAR_ALL_APPLICATION_QUEUES_FILTERS_SUCCESS:
      return {
        ...state,
        applicationQueueDetails: state.applicationQueueDetails.map((aqd) => {
          return ({
            ...aqd,
            filters: {
              ...aqd.filters,
              filter: undefined
            }
          })
        })
      }
    case UPDATE_APPLICATION_QUEUE_FILTERS_SUCCESS:
      return {
        ...state,
        applicationQueueDetails: state.applicationQueueDetails.map((aqd) => {
          if (aqd.id === action.payload.queueId) {
            return {
              ...aqd,
              filters: action.payload.filters,
            };
          } else {
            return aqd;
          }
        }),
      };
    case UPDATE_KEY_FACTOR_VALIDATION_RESULTS:
      return {
        ...state,
        keyFactorValidationResults: action.payload,
      };
    case SET_VEHICLE_INFO:
      if (action.payload.vehicleUpdateInfo.model === 'Not Found') {
        return {
          ...state,
          editingApp: state.editingApp
            ? {
              ...state.editingApp,
              vehicle: state.editingApp.vehicle
                ? {
                    ...state.editingApp.vehicle,
                    make: '',
                    model: 'Not Found',
                    year: 0,
                    color: '',
                    nadaValue: undefined,
                    mileage: 0,
                    engineSize: undefined,
                  }
                : state.editingApp.vehicle,
              }
            : undefined,
        };
      }
      const make = state.editingApp?.availableVehicleMakes?.find(
        (vm) => vm.substring(0, 2).toUpperCase() === action.payload.vehicleUpdateInfo.make.substring(0, 2).toUpperCase()
      );
      const model = action.payload.vehicleUpdateInfo.model;
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              vehicle:
                state.editingApp.vehicle && make && model
                  ? {
                      ...state.editingApp.vehicle,
                      make: make,
                      model: model,
                      year: action.payload.vehicleUpdateInfo.year,
                      // color: '',
                      // mileage: undefined,
                      // engineSize: undefined
                    }
                  : state.editingApp.vehicle,
            }
          : undefined,
      };
    case GET_700_CREDIT_TRANSACTION_ID:
      return {
        ...state,
        creditPullPrimaryTransactionId: action.payload.creditPullPrimaryTransactionId,
      };
    case GET_APPLICATION_SCORE:
      return {
        ...state,
        applicationScore: action.payload.applicationScore,
      };
    case CLEAR_APPLICATION_SCORE:
      return {
        ...state,
        applicationScore: undefined,
      };
    case GET_PREVIOUS_AMS_LOANS_SUCCESS:
      return {
        ...state,
        previousAmsLoans: action.payload,
      };
    case GET_DOWN_PAYMENT_HISTORIES_SUCCESS:
      return {
        ...state,
        applicationDownPaymentResponses: action.payload,
      };
    case CLEAR_PREVIOUS_AMS_LOANS:
      return {
        ...state,
        previousAmsLoans: undefined,
      };
    case CLEAR_APPLICATION_REHASHES:
      return {
        ...state,
        applicationRehashes: [],
      };
    case SET_VEHICLE_JDPOWER:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              vehicle: state.editingApp.vehicle
                ? {
                    ...state.editingApp.vehicle,
                    vehicleJdPower: { ...action.payload.vehicleJdPower },
                    bookoutValue: action.payload.vehicleJdPower.bookout ?? state.editingApp.vehicle.bookoutValue,
                  }
                : state.editingApp.vehicle,
              applicationQuotes: action.payload.isIndirectApplication
                ? state.editingApp.applicationQuotes.map((aq) => {
                    if (aq.quote.quoteType === IndirectQuoteType.Underwriter) {
                      return {
                        ...aq,
                        quote: {
                          ...aq.quote,
                          nadavalue: action.payload.vehicleJdPower.bookout ?? aq.quote.nadavalue,
                        },
                      };
                    } else {
                      return aq;
                    }
                  })
                : state.editingApp.applicationQuotes,
            }
          : undefined,
      };
    case GET_APPLICATION_REHASH_SUCCESS:
      return {
        ...state,
        applicationRehashes: action.payload.applicationRehashes.map((ar) => {
          return { ...ar };
        }),
      };
    case UPDATE_APPLICATION_FINANCE_QUOTES_SUCCESS:
      const solvedQuotes = action.payload.carletonCalculationResult.financeQuotes;
      return {
        ...state,
        loading: false,
        financeQuoteIsDirty: false,
        lastSolvedSelectedFinanceQuote: buildLastSolvedSelectedFinanceQuote(solvedQuotes),
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              vehicle: action.payload.newVehicle ?? state.editingApp.vehicle,
              vehicleId: action.payload.newVehicle?.id ?? state.editingApp.vehicleId,
              appStatusId: hasValue(action.payload.carletonCalculationResult.newAppStatusId) ? action.payload.carletonCalculationResult.newAppStatusId! : state.editingApp.appStatusId,
              financeQuotes: action.payload.carletonCalculationResult.financeQuotes.map((financeQuote) => {
                return {
                  ...financeQuote,
                  financeQuoteFees: financeQuote.financeQuoteFees.map((fee) => {
                    return {
                      ...fee,
                    };
                  }),
                  financeQuoteTaxes: financeQuote.financeQuoteTaxes.map((tax) => {
                    return {
                      ...tax,
                    };
                  }),
                  financeQuoteDeferredPayments: financeQuote.financeQuoteDeferredPayments.map(
                    (payment) => {
                      return {
                        ...payment,
                      };
                    }
                  ),
                };
              }),
            }
          : undefined,
      };
    case UPDATE_APPLICATION_FINANCE_QUOTES:
      return {
        ...state,
        loading: true
      };
    case SOLVE_LEASE_QUOTE_SUCCESS: {
      const { result, newVehicle } = action.payload;
      if (state.editingApp?.id !== result.applicationId) {
        return state; // the user left that application while it was solving
      }
      // No quote back means the server refused before saving: keep the page's edits and vehicle.
      const saved = !!result.applicationLeaseQuote;
      const vehicleAttached = saved && !!newVehicle && result.vehicleId === newVehicle.id;
      return {
        ...state,
        applicationLeaseQuoteIsDirty: saved ? false : state.applicationLeaseQuoteIsDirty,
        applicationLeaseQuoteNeedsSolve: saved ? result.leaseQuoteNeedsSolve : state.applicationLeaseQuoteNeedsSolve,
        leaseQuoteSolvedRollback: saved && result.errors.length === 0
          ? result.applicationLeaseQuote!.totalDownRollback ?? 0
          : state.leaseQuoteSolvedRollback,
        editingApp: {
          ...state.editingApp,
          applicationLeaseQuote: saved ? result.applicationLeaseQuote! : state.editingApp.applicationLeaseQuote,
          vehicle: vehicleAttached ? newVehicle : state.editingApp.vehicle,
          vehicleId: vehicleAttached ? newVehicle!.id : state.editingApp.vehicleId,
          appStatusId: result.newAppStatusId ?? state.editingApp.appStatusId,
          // Kept as the server's text, as the application load stores it, so the save check compares like with like.
          modifiedDate: result.applicationModifiedDate ? (result.applicationModifiedDate as unknown as Date) : state.editingApp.modifiedDate,
        },
      };
    }
    case SET_LEASE_QUOTE_NEEDS_SOLVE:
      return {
        ...state,
        applicationLeaseQuoteNeedsSolve: true,
      };
    case CREATE_INCOME_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: state.editingApp.appCustomers.map((appCustomer) => {
                if (appCustomer.customer.id === action.payload.ownerId) {
                  return {
                    ...appCustomer,
                    customer: {
                      ...appCustomer.customer,
                      incomes: appCustomer.customer.incomes
                        ? [...appCustomer.customer.incomes, action.payload.income]
                        : [action.payload.income],
                    },
                  };
                }
                return appCustomer;
              }),
            }
          : undefined,
      };
    case UPDATE_INCOME_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: state.editingApp.appCustomers.map((appCustomer) => {
                if (appCustomer.customer.id === action.payload.ownerId) {
                  return {
                    ...appCustomer,
                    customer: {
                      ...appCustomer.customer,
                      incomes: appCustomer.customer.incomes
                        ? appCustomer.customer.incomes.map((income) => {
                            if (income.id === action.payload.income.id) {
                              return action.payload.income;
                            }
                            return income;
                          })
                        : [],
                    },
                  };
                }
                return appCustomer;
              }),
            }
          : undefined,
      };
    case DELETE_INCOME_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: state.editingApp.appCustomers.map((appCustomer) => {
                if (appCustomer.customer.id === action.payload.ownerId) {
                  return {
                    ...appCustomer,
                    customer: {
                      ...appCustomer.customer,
                      incomes: appCustomer.customer.incomes
                        ? appCustomer.customer.incomes.filter((income) => income.id !== action.payload.incomeId)
                        : [],
                    },
                  };
                }
                return appCustomer;
              }),
            }
          : undefined,
      };
    case SEND_CUSTOMER_REFERENCES_TO_AMS_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appCustomers: state.editingApp.appCustomers.map((appCustomer) => {
                const customerReferencesForCustomer = action.payload.customerReferences.filter(
                  (cr) => cr.customerId === appCustomer.customerId
                );
                return {
                  ...appCustomer,
                  customer: {
                    ...appCustomer.customer,
                    customerReferences: [
                      ...appCustomer.customer.customerReferences.map((customerReference) => {
                        const updatedCustomerReference = customerReferencesForCustomer.find(
                          (cr) => cr.id === customerReference.id
                        );
                        if (updatedCustomerReference) {
                          return updatedCustomerReference;
                        }
                        return customerReference;
                      }),
                    ],
                  },
                };
              }),
            }
          : undefined,
      };
    case UPDATE_VEHICLE_SUCCESS:
      const leaseVehicleEdit = getLeaseVehicleEditEffect(state.editingApp, action.payload.vehicle);
      return {
        ...state,
        applicationLeaseQuoteNeedsSolve: state.applicationLeaseQuoteNeedsSolve || leaseVehicleEdit.needsSolve,
        vehicles: state.vehicles.map((v) => {
          if (v.id === action.payload.vehicle.id) {
            return {
              ...v,
              carPrice: action.payload.vehicle.carPrice,
              mileage: action.payload.vehicle.mileage,
              make: action.payload.vehicle.make,
              model: action.payload.vehicle.model,
              year: action.payload.vehicle.year,
              body: action.payload.vehicle.body,
              bookoutValue: action.payload.vehicle.bookoutValue,
              bookoutSourceId: action.payload.vehicle.bookoutSourceId,
              otherBookoutSource: action.payload.vehicle.otherBookoutSource,
              acv: action.payload.vehicle.acv,
              locationOfPurchaseId: action.payload.vehicle.locationOfPurchaseId
            };
          } else {
            return v;
          }
        }),
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              appStatusId: hasValue(action.payload.newAppStatusId) ? action.payload.newAppStatusId! : state.editingApp.appStatusId,
              applicationLeaseQuote: leaseVehicleEdit.quote ?? state.editingApp.applicationLeaseQuote,
              vehicle:
                state.editingApp.vehicle && state.editingApp.vehicle.id === action.payload.vehicle.id
                  ? {
                      ...state.editingApp.vehicle,
                      carPrice: action.payload.vehicle.carPrice,
                      mileage: action.payload.vehicle.mileage,
                      make: action.payload.vehicle.make,
                      model: action.payload.vehicle.model,
                      year: action.payload.vehicle.year,
                      body: action.payload.vehicle.body,
                      bookoutValue: action.payload.vehicle.bookoutValue,
                      bookoutSourceId: action.payload.vehicle.bookoutSourceId,
                      otherBookoutSource: action.payload.vehicle.otherBookoutSource,
                      acv: action.payload.vehicle.acv,
                      locationOfPurchaseId: action.payload.vehicle.locationOfPurchaseId
                    }
                  : state.editingApp.vehicle,
              applicationQuotes: action.payload.isIndirectApplication
                ? state.editingApp.applicationQuotes.map((aq) => {
                    if (aq.quote.quoteType === IndirectQuoteType.Underwriter) {
                      return {
                        ...aq,
                        quote: {
                          ...aq.quote,
                          nadavalue: action.payload.vehicle.bookoutValue ?? aq.quote.nadavalue,
                        },
                      };
                    } else {
                      return aq;
                    }
                  })
                : state.editingApp.applicationQuotes,
            }
          : undefined,
        // dealertrackDealerDecisionData: state.dealertrackDealerDecisionData ? {
        //   ...state.dealertrackDealerDecisionData,
        //   cashPrice: state.editingApp?.appSource?.toUpperCase() === Constants.appSources.dealerFlow
        //     ? action.payload.vehicle.carPrice
        //     : state.dealertrackDealerDecisionData.cashPrice,
        // } : initialState.dealertrackDealerDecisionData
      };
    case ADD_NEW_APP_VEHICLE:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
              ...state.editingApp,
              vehicle: action.payload.vehicleAddInfo,
              vehicleId: action.payload.vehicleAddInfo.id,
            }
          : undefined,
      };
    case SET_APP_LOADED_BUSINESS_RULES_HAVE_RUN:
      return {
        ...state,
        appLoadedBusinessRulesHaveRun: true,
      };
    case LOAD_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        releaseNotes: action.payload.releaseNotes,
      };
    case LOAD_CURRENT_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        releaseNotes: action.payload.releaseNotes,
      };
    case GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS:
      return {
        ...state,
        applicationPerformanceIndicatorEvaluations: action.payload.applicationPerformanceIndicatorEvaluations,
      };
    case GET_PERFORMANCE_EVALUATION_SUCCESS:
      return {
        ...state,
        scoreEditorPerformanceIndicatorEvaluations: [...action.payload.scoreEditorPerformanceIndicatorEvaluations],
      };
    case CREATE_CUSTOMER_REFERENCE_SUCCESS:
      return {
        ...state,
        editingApp: {
          ...state.editingApp!,
          appCustomers: state.editingApp!.appCustomers.map((appCustomer) => {
            if (appCustomer.customerId === action.payload.customerReference.customerId) {
              return {
                ...appCustomer,
                customer: {
                  ...appCustomer.customer,
                  customerReferences: [...appCustomer.customer.customerReferences, action.payload.customerReference],
                },
              };
            }
            return appCustomer;
          }),
        },
      };
    case UPDATE_CUSTOMER_REFERENCE_SUCCESS:
      return {
        ...state,
        editingApp: {
          ...state.editingApp!,
          appCustomers: state.editingApp!.appCustomers.map((appCustomer) => {
            if (appCustomer.customerId === action.payload.customerReference.customerId) {
              return {
                ...appCustomer,
                customer: {
                  ...appCustomer.customer,
                  customerReferences: appCustomer.customer.customerReferences.map((cr) => {
                    if (cr.id === action.payload.customerReference.id) {
                      return action.payload.customerReference;
                    }
                    return cr;
                  }),
                },
              };
            }
            return appCustomer;
          }),
        },
      };
    case UPDATE_CUSTOMER_REFERENCE_VERIFICATION_SUCCESS:
      return {
        ...state,
        editingApp: {
          ...state.editingApp!,
          appCustomers: state.editingApp!.appCustomers.map((appCustomer) => {
            if (appCustomer.customer.customerReferences.some((cr) => cr.id === action.payload.customerReferenceId)) {
              return {
                ...appCustomer,
                customer: {
                  ...appCustomer.customer,
                  customerReferences: appCustomer.customer.customerReferences.map((cr) => {
                    if (cr.id === action.payload.customerReferenceId) {
                      return {
                        ...cr,
                        isVerified: action.payload.isVerified,
                        modifiedBy: action.payload.modifiedByName,
                        modifiedDate: new Date(),
                      };
                    }
                    return cr;
                  }),
                },
              };
            }
            return appCustomer;
          }),
        },
      };
    case DELETE_CUSTOMER_REFERENCE_SUCCESS:
      return {
        ...state,
        editingApp: {
          ...state.editingApp!,
          appCustomers: state.editingApp!.appCustomers.map((appCustomer) => {
            if (appCustomer.customer.customerReferences.some((cr) => cr.id === action.payload.customerReferenceId)) {
              return {
                ...appCustomer,
                customer: {
                  ...appCustomer.customer,
                  customerReferences: appCustomer.customer.customerReferences.filter(
                    (cr) => cr.id !== action.payload.customerReferenceId
                  ),
                },
              };
            }
            return appCustomer;
          }),
        },
      };
    case CREATE_EMPLOYEE_APPLICATION_HISTORY_SUCCESS:
      // Returns an array that removes any previous instance of that app, if exists, and then places this new one at the beginning
      return {
        ...state,
        employeeApplicationHistories: [
          action.payload,
          ...state.employeeApplicationHistories.filter((h) => h.applicationId !== action.payload.applicationId),
        ].slice(0, numberOfEmployeeApplicationHistoriesToTrack),
      };
    case LOAD_EMPLOYEE_APPLICATION_HISTORIES_SUCCESS:
      return {
        ...state,
        employeeApplicationHistories: action.payload,
      };
    case CREATE_APPLICATION_DOWN_PAYMENT_REQUEST:
      return {
        ...state,
        downPaymentRequestError: null,
      };
    case CREATE_APPLICATION_DOWN_PAYMENT_REQUEST_SUCCESS:
      return {
        ...state,
        newlyCreatedDownPaymentRequest: action.payload,
        downPaymentRequestError: null,
        editingApp: {
          ...state.editingApp!,
          applicationDownPaymentRequests: [action.payload, ...state.editingApp!.applicationDownPaymentRequests],
        },
      };
    case CREATE_APPLICATION_DOWN_PAYMENT_REQUEST_FAILURE:
      return {
        ...state,
        downPaymentRequestError: action.payload,
      };
    case CLEAR_NEWLY_CREATED_DOWN_PAYMENT_REQUEST:
      return {
        ...state,
        newlyCreatedDownPaymentRequest: null,
        downPaymentRequestError: null,
      };
    case GET_CARLETON_APR_FOR_APPLICATION_FUNDING_SUCCESS:
      return {
        ...state,
        editingApp: {
          ...state.editingApp!,
          applicationFunding: action.payload,
        },
      };
    case SET_GLOBAL_SEARCH_TEXT:
      return {
        ...state,
        globalSearchText: action.payload,
      };
    case SET_IS_GLOBALLY_SEARCHING:
      return {
        ...state,
        isGloballySearchingApps: action.payload,
      };
    case CANCEL_GLOBAL_SEARCH:
      return {
        ...state,
        isGloballySearchingApps: false,
        loadingGlobalSearchPage: false,
        globalSearchText: '',
        globalSearchPage: {
          applications: [],
          count: 0,
        },
      };
    case LOAD_GLOBAL_SEARCH_ITEMS:
      return {
        ...state,
        loadingGlobalSearchPage: true,
      };
    case LOAD_GLOBAL_SEARCH_ITEMS_SUCCESS:
      return {
        ...state,
        globalSearchPage: action.payload,
        loadingGlobalSearchPage: false,
      };
    case SET_IS_LOADING_GLOBAL_SEARCH_PAGE:
      return {
        ...state,
        loadingGlobalSearchPage: action.payload,
      };
    case UPDATE_AMS_CUSTOMER_NUMBER_SUCCESS:
      return {
        ...state,
        editingApp: state.editingApp
          ? {
            ...state.editingApp,
            appCustomers: state.editingApp.appCustomers.map(appCustomer => {
              const matchedAppCustomerPair = action.payload.find(pair => pair.customerId.toLowerCase() === appCustomer.customerId.toLowerCase());
              if (matchedAppCustomerPair) {
                return {
                  ...appCustomer,
                  customer: {
                    ...appCustomer.customer,
                    amsCustomerNumber: matchedAppCustomerPair?.amsCustomerNumber
                  }
                };
              }
              return appCustomer;
            })
          }
          : state.editingApp,
      };
    case GET_NEW_SIGNED_URL_SUCCESS:
      return {
        ...state,
        signedUrls: {
          ...state.signedUrls,
          [action.payload.customerCreditId]: action.payload.signedUrl,
        },
      };
    case GET_SIGNED_URLS_SUCCESS:
      return {
        ...state,
        signedUrls: {
          ...state.signedUrls,
          ...action.payload.signedUrls,
        },
      };
    case VOID_DOWN_PAYMENT_SUCCESS:
      // Removes that down payment from the list that is shown
      return {
        ...state,
        applicationDownPaymentResponses: state.applicationDownPaymentResponses?.filter(dpr => dpr.id !== action.payload.voidedApplicationDownPaymentResponseId)
      };
    default:
      return state;
  }
};
